import { useState } from 'react';
import { Center, Loader, Stack, Text } from '@mantine/core';
// import { useViewportSize } from '@mantine/hooks'; // DISABLED: Causing re-renders on Android keyboard
import { useMatch } from '@tanstack/react-location';
import { LocationGenerics } from '../../routes/types/routing.types';
import { useClientForm } from './api/REST/useClientForm';
import { ClientForm, isVerificationRequired } from './api/types/digitalForms.api.types';
import { SurveyFormWrapper } from './form/components/SurveyFormWrapper';
import { ZipcodeVerification } from './form/components/ZipcodeVerification';

export const DigitalFormsMain = () => {
  const { params } = useMatch<LocationGenerics>();
  const { uuid } = params;
  const { data, isLoading } = useClientForm({ opcode: 'brePraw1uc8fifek' }, { uuid });
  const [verifiedClientForm, setVerifiedClientForm] = useState<ClientForm | null>(null);

  const renderContent = () => {
    if (isLoading) {
      return (
        <Center aria-live="polite" role="status">
          <Loader color="gray" size="lg" type="bars" aria-label="Loading digital form" />
          <span className="visually-hidden">Loading, please wait.</span>
        </Center>
      );
    }

    if (!data) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
          }}
        >
          <div
            style={{
              padding: '3rem',
              borderRadius: '12px',
              background: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              textAlign: 'center',
              maxWidth: '400px',
            }}
          >
            <Text size="lg" style={{ color: '#495057' }}>
              Form not found or has already been completed.
            </Text>
          </div>
        </div>
      );
    }

    // Verification required — show zipcode verification page
    if (isVerificationRequired(data)) {
      // If already verified, show the form
      if (verifiedClientForm) {
        return (
          <Stack role="region" aria-label="Digital form" style={{}}>
            <SurveyFormWrapper clientForm={verifiedClientForm} />
          </Stack>
        );
      }

      return <ZipcodeVerification metadata={data} onVerificationSuccess={setVerifiedClientForm} />;
    }

    // Full ClientForm — no verification needed
    return (
      <Stack role="region" aria-label="Digital form" style={{}}>
        <SurveyFormWrapper clientForm={data} />
      </Stack>
    );
  };

  return <main role="main" aria-labelledby="form-title">{renderContent()}</main>;
};
